import React, { useState, useEffect, useRef } from "react";
import classNames from "classnames";
import { Redirect, Route, Switch, useHistory } from "react-router-dom";
import { CSSTransition } from "react-transition-group";
import { useIdleTimer } from "react-idle-timer";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { AppTopbar } from "./AppTopbar";
import { AppMenu } from "./AppMenu";

import CreateSingleTransaction from "./pages/transaction/singleTransaction/CreateSingleTransaction";
import ReviewTransaction from "./pages/transaction/reviewTransaction/ReviewTrasaction";

import { Dashboard } from "./components/Dashboard";

import "primereact/resources/themes/saga-green/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";
import "prismjs/themes/prism-coy.css";
import "@fullcalendar/core/main.css";
import "@fullcalendar/daygrid/main.css";
import "@fullcalendar/timegrid/main.css";
import "./layout/flags/flags.css";
import "./layout/layout.scss";
import "./App.scss";

import { useSelector } from "react-redux";
import AddEditGroupProfile from "./pages/groupProfile/AddEditGroupProfile";
import CompanyProducts from "./pages/company/companyProducts/CompanyProducts";
import AddEditCompanyProducts from "./pages/company/companyProducts/AddEditCompanyProducts";
import AddEditCompanyProfile from "./pages/company/companyProfileSetup/AddEditCompanyProfile";
import CompanyDetails from "./pages/company/companyDetails/CompanyDetails";
import Roles from "./pages/UserManagement/roles/Roles";
import Module from "./pages/UserManagement/module/Module";
import Menu from "./pages/UserManagement/menu/Menu";
import ChangePassword from "./pages/login/ChangePassword";
import ForgetPasswordOTP from "./pages/login/forgetpassword/ForgetPasswordOTP";
import RoleRights from "./pages/UserManagement/rolerights/RoleRights";
import BranchUser from "./pages/branchUser/BranchUser";
import OnlineDeposit from "./pages/onlineDeposit/OnlineDeposit";
import Liquidation from "./pages/liquidation/Liquidation";
import AddEditParserHead from "./pages/company/parser/AddEditParserHead";
import Lodegment from "./pages/lodegment/Lodegment";
import AddCustomerBulkUpload from "./pages/customerBulkUpload/AddCustomerBulkUpload";
import CashOverCounter from "./pages/cashOverCounter/CashOverCounter";
import InwardClearing from "./pages/inwardClearing/InwardClearing";
import UtilityBillCollection from "./pages/utilityBillCollection/UtilityBillCollection";
import AuthorizeTransaction from "./pages/branch//authTransaction/AuthorizeTransaction";
import BranchAuthorization from "./pages/branchAuthorization";
import GeneratePin from "./pages/login/GeneratePin";
import AuthCompanyTransaction from "./pages/company/authCompanyTransaction/AuthCompanyTransaction";
import BankManagement from "./pages/bankAndBranchManagement/bankManagement/BankManagement";
import AddEditBankManagement from "./pages/bankAndBranchManagement/bankManagement/AddEditBankManagement";
import BankBranchManagement from "./pages/bankAndBranchManagement/bankBranchManagement/BankBranchManagement";
import AddEditApproveBankBranchManagement from "./pages/bankAndBranchManagement/bankBranchManagement/AddEditApproveBankBranchManagement";
import AddBulkBranch from "./pages/bankAndBranchManagement/bankBranchManagement/AddBulkBranch";
import BankBranchUndefined from "./pages/bankAndBranchManagement/bankBranchManagement/BankBranchUndefined";
import CountryManagement from "./pages/locationManagement/countryManagement/CountryManagement";
import AddEditCountryManagement from "./pages/locationManagement/countryManagement/AddEditCountryManagement";
import ProvinceManagement from "./pages/locationManagement/provinceManagement/ProvinceManagement";
import AddEditProvinceManagement from "./pages/locationManagement/provinceManagement/AddEditProvinceManagement";
import FileStatuses from "./pages/customerBulkUpload/FileStatuses";
import RecoverNewPassword from "./pages/login/forgetpassword/RecoverNewPassword";
import BlockUnblockAccount from "./pages/blockUnblockAccount/BlockUnblockAccount";
import AccountStatementInquiry from "./pages/accountStatementInquiry/AccountStatementInquiry";
import MpinResetInquiry from "./pages/mpinResetInquiry/MpinResetInquiry";
import ResetPassword from "./pages/login/ResetPassword";
import LoginVerifyOtp from "./pages/login/LoginVerifyOtp";
import UnPostedTransaction from "./pages/customerBulkUpload/UnPostedTransaction";
import DeviceManager from "./pages/deviceManager/DeviceManager";
import AtmCardStatus from "./pages/atm/AtmCardStatus";
import ChangeCardPin from "./pages/atm/ChangeCardPin";
import CompanyProfile from "./pages/company/companyProfileSetup/CompanyProfile";
import FileStatusSummary from "./pages/customerBulkUpload/FileStatusSummary";
import TransactionReport from "./pages/Reports/TransactionReport";
import Analytics from "./pages/dashboard/Analytics";
import MenuContext from "./pages/MenuContext";

const App = () => {
  const [layoutMode] = useState("static");
  const [layoutColorMode] = useState("light");
  const [staticMenuInactive, setStaticMenuInactive] = useState(false);
  const [overlayMenuActive, setOverlayMenuActive] = useState(false);
  const [mobileMenuActive, setMobileMenuActive] = useState(false);
  const [inputStyle, setInputStyle] = useState("outlined");
  const [ripple] = useState(true);
  const [dynamicroutes, setdynamicroutes] = useState([]);
  const [clickedItem, setClickedItem] = useState(null);

  const auth = useSelector((state) => state?.authenticationSlice?.token);
  const nav = useSelector((state) => state?.authenticationSlice?.nav);
  const pwdUpdateFlag = useSelector(
    (state) => state?.authenticationSlice?.pwdUpdateFlag
  );
  require("dotenv").config();

  const sidebar = useRef();

  const history = useHistory();

  let menuClick = false;
  //  const minutes = 840000;  Refresh Token after 14minutes

  useEffect(() => {
    if (mobileMenuActive) {
      addClass(document.body, "body-overflow-hidden");
    } else {
      removeClass(document.body, "body-overflow-hidden");
    }
  }, [mobileMenuActive]);

  const onInputStyleChange = (inputStyle) => {
    setInputStyle(inputStyle);
  };

  // const onRipple = (e) => {
  //     PrimeReact.ripple = e.value;
  //     setRipple(e.value);
  // };

  // const onLayoutModeChange = (mode) => {
  //     setLayoutMode(mode);
  // };

  // const onColorModeChange = (mode) => {
  //     setLayoutColorMode(mode);
  // };

  const onWrapperClick = (event) => {
    if (!menuClick) {
      setOverlayMenuActive(false);
      setMobileMenuActive(false);
    }
    menuClick = false;
  };

  const onToggleMenu = (event) => {
    menuClick = true;

    if (isDesktop()) {
      if (layoutMode === "overlay") {
        setOverlayMenuActive((prevState) => !prevState);
      } else if (layoutMode === "static") {
        setStaticMenuInactive((prevState) => !prevState);
      }
    } else {
      setMobileMenuActive((prevState) => !prevState);
    }
    event.preventDefault();
  };

  const onSidebarClick = () => {
    menuClick = true;
  };

  const onMenuItemClick = (event) => {
    if (event?.item?.items === "null" || event?.item?.items === null) {
      setClickedItem(event?.item?.label);
    }
    if (!event.item.items) {
      setOverlayMenuActive(false);
      setMobileMenuActive(false);
    }
  };

  const menu = JSON.parse(localStorage.getItem("nav"));

  menu?.forEach((item) => {
    if (item.label === "Customer Management") {
      item.items = item.items.filter(
        (subItem) =>
          subItem.label !== "Change Card PIN" &&
          subItem.label !== "ATM Card Status"
      );
    }
  });

  const addClass = (element, className) => {
    if (element.classList) element.classList.add(className);
    else element.className += " " + className;
  };

  const removeClass = (element, className) => {
    if (element.classList) element.classList.remove(className);
    else
      element.className = element.className.replace(
        new RegExp(
          "(^|\\b)" + className.split(" ").join("|") + "(\\b|$)",
          "gi"
        ),
        " "
      );
  };

  const isDesktop = () => {
    return window.innerWidth > 1024;
  };

  const isSidebarVisible = () => {
    if (isDesktop()) {
      if (layoutMode === "static") return !staticMenuInactive;
      else if (layoutMode === "overlay") return overlayMenuActive;
      else return true;
    }

    return true;
  };

  const logo =
    layoutColorMode === "dark"
      ? "assets/layout/images/zbizLogo.png"
      : "assets/layout/images/zbizLogo.png";

  const wrapperClass = classNames("layout-wrapper", {
    "layout-overlay": layoutMode === "overlay",
    "layout-static": layoutMode === "static",
    "layout-static-sidebar-inactive":
      staticMenuInactive && layoutMode === "static",
    "layout-overlay-sidebar-active":
      overlayMenuActive && layoutMode === "overlay",
    "layout-mobile-sidebar-active": mobileMenuActive,
    "p-input-filled": inputStyle === "filled",
    "p-ripple-disabled": ripple === false,
  });

  const sidebarClassName = classNames("layout-sidebar", {
    "layout-sidebar-dark": layoutColorMode === "dark",
    "layout-sidebar-light": layoutColorMode === "light",
  });

  const checks = (item, newdynamicroutes) => {
    item &&
      item.length &&
      item.forEach((elm) => {
        if ("items" in elm) {
          elm?.items.length &&
            elm?.items.forEach((item) => {
              if (item?.to !== null) {
                newdynamicroutes.push(item);
              }
            });
        }
      });
    return newdynamicroutes;
  };

  useEffect(() => {
    if (nav) {
      setdynamicroutes(checks(JSON.parse(nav), []));
    }
  }, [nav]);

  const handleLogout = () => {
    if (localStorage.getItem("sessionTimeOut")) {
      localStorage.clear();
      window.location.reload();
      toast.warn("Logged out because of inactivity");
    }
  };

  useIdleTimer({
    timeout: localStorage.getItem("sessionTimeOut") || 600000,
    onIdle: window?.location?.host?.includes("localhost")
      ? () => {}
      : handleLogout,
    debounce: 500,
  });

  const isPermitted = (route) => {
    let permittedRoutes = localStorage.getItem("permsArr");
    return permittedRoutes?.includes(route);
  };

  useEffect(() => {
    if (window.self !== window.top) {
      document.body.style.display = "none";
      window.top.location.href = window.self.location.href;
      console.error("Clickjacking attempt detected!");
    }
  }, []);

  return (
    <MenuContext.Provider value={{ clickedItem, onMenuItemClick }}>
      <div className={wrapperClass} onClick={onWrapperClick}>
        <ToastContainer></ToastContainer>
        {auth && pwdUpdateFlag === "Y" && (
          <>
            <AppTopbar onToggleMenu={onToggleMenu} />
            <CSSTransition
              classNames="layout-sidebar"
              timeout={{ enter: 200, exit: 200 }}
              in={isSidebarVisible()}
              unmountOnExit
            >
              <div
                ref={sidebar}
                className={sidebarClassName}
                onClick={onSidebarClick}
              >
                <div
                  className="layout-logo"
                  style={{ cursor: "pointer" }}
                  onClick={() => history.push("/")}
                >
                  <img width="180px" alt="Logo" src={logo} />
                </div>
                {/* <AppProfile /> */}
                <AppMenu model={menu} onMenuItemClick={onMenuItemClick} />
              </div>
            </CSSTransition>
          </>
        )}
        <div>
          <Switch>
            {pwdUpdateFlag === "N" ? (
              <div>
                <Switch>
                  <Route
                    exact
                    path="/resetpassword"
                    component={ResetPassword}
                  />
                  <Route path="/" exact component={LoginVerifyOtp} />
                  <Redirect to="/resetpassword" />
                </Switch>
              </div>
            ) : !auth ? (
              <div>
                <Switch>
                  <Route path="/" exact component={LoginVerifyOtp} />
                  <Route
                    exact
                    path="/forgetpassword"
                    component={ForgetPasswordOTP}
                  />
                  <Route
                    exact
                    path="/setnewpassword/:jwt"
                    component={RecoverNewPassword}
                  />

                  <Redirect to="/" />
                </Switch>
              </div>
            ) : (
              <div className="layout-main">
                <Switch>
                  <Route exact path="/" component={Dashboard} />
                  {/* {dynamicroutes.map((route, index) =>
                  route.to === "/groupprofile" ? (
                    <Route
                      key={index}
                      exact
                      path={route.to}
                      component={() => (
                        <GroupProfile
                          authorizeAllowed={route?.authorizeAllowed}
                        />
                      )}
                    />
                  ) : (
                    ""
                  )
                )} */}
                  {/* {routes && routes.includes("/groupprofile") && <Route exact path="/groupprofile" component={GroupProfile} />} */}
                  {
                    <Route
                      exact
                      path="/groupprofileadd"
                      // component={AddEditGroupProfile}
                      render={() =>
                        isPermitted("/groupprofileadd") ? (
                          <AddEditGroupProfile />
                        ) : (
                          <Dashboard />
                        )
                      }
                    />
                  }
                  {
                    <Route
                      exact
                      path="/companyproducts"
                      // component={CompanyProducts}
                      render={() =>
                        isPermitted("/companyproducts") ? (
                          <CompanyProducts />
                        ) : (
                          <Dashboard />
                        )
                      }
                    />
                  }
                  {
                    <Route
                      exact
                      path="/companyproductsadd"
                      // component={AddEditCompanyProducts}
                      render={() =>
                        isPermitted("/companyproductsadd") ? (
                          <AddEditCompanyProducts />
                        ) : (
                          <Dashboard />
                        )
                      }
                    />
                  }
                  {
                    <Route
                      exact
                      path="/companyprofilesetup"
                      // component={companyProfile}
                      render={() =>
                        isPermitted("/companyprofilesetup") ? (
                          <CompanyProfile />
                        ) : (
                          <Dashboard />
                        )
                      }
                    />
                  }
                  {
                    <Route
                      exact
                      path="/companyprofilesetupadd"
                      // component={AddEditCompanyProfile}
                      render={() =>
                        isPermitted("/companyprofilesetupadd") ? (
                          <AddEditCompanyProfile />
                        ) : (
                          <Dashboard />
                        )
                      }
                    />
                  }
                  {
                    <Route
                      exact
                      path="/companydetails"
                      // component={CompanyDetails}
                      render={() =>
                        isPermitted("/companydetails") ? (
                          <CompanyDetails />
                        ) : (
                          <Dashboard />
                        )
                      }
                    />
                  }
                  {
                    <Route
                      exact
                      path="/getroles"
                      // component={Roles}
                      render={() =>
                        isPermitted("/getroles") ? <Roles /> : <Dashboard />
                      }
                    />
                  }
                  {
                    <Route
                      exact
                      path="/getmodule"
                      render={() =>
                        isPermitted("/getmodule") ? <Module /> : <Dashboard />
                      }
                    />
                  }
                  {/* {<Route exact path="/groupprofile" component={() => <GroupProfile foo="bar" />} />} */}
                  {
                    <Route
                      exact
                      path="/getmenu/:moduleId"
                      render={() =>
                        isPermitted("/getmenu/:moduleId") ? (
                          <Menu />
                        ) : (
                          <Dashboard />
                        )
                      }
                    />
                  }
                  {
                    <Route
                      exact
                      path="/changepassword"
                      // component={ChangePassword}
                      render={() =>
                        isPermitted("/changepassword") ? (
                          <ChangePassword />
                        ) : (
                          <Dashboard />
                        )
                      }
                    />
                  }
                  {
                    <Route
                      exact
                      path="/getrolerights/:roleId"
                      // component={RoleRights}
                      render={() =>
                        isPermitted("/getrolerights/:roleId") ? (
                          <RoleRights />
                        ) : (
                          <Dashboard />
                        )
                      }
                    />
                  }
                  {
                    <Route
                      exact
                      path="/branchuser"
                      // component={BranchUser}
                      render={() =>
                        isPermitted("/branchuser") ? (
                          <BranchUser />
                        ) : (
                          <Dashboard />
                        )
                      }
                    />
                  }
                  {
                    <Route
                      exact
                      path="/onlinedeposit"
                      // component={OnlineDeposit}
                      render={() =>
                        isPermitted("/onlinedeposit") ? (
                          <OnlineDeposit />
                        ) : (
                          <Dashboard />
                        )
                      }
                    />
                  }
                  {
                    <Route
                      exact
                      path="/liquidation"
                      // component={Liquidation}
                      render={() =>
                        isPermitted("/liquidation") ? (
                          <Liquidation />
                        ) : (
                          <Dashboard />
                        )
                      }
                    />
                  }
                  {
                    <Route
                      exact
                      path="/parser"
                      //  component={AddEditParserHead}
                      render={() =>
                        isPermitted("/parser") ? (
                          <AddEditParserHead />
                        ) : (
                          <Dashboard />
                        )
                      }
                    />
                  }
                  {
                    <Route
                      exact
                      path="/lodegment"
                      // component={Lodegment}
                      render={() =>
                        isPermitted("/lodegment") ? (
                          <Lodegment />
                        ) : (
                          <Dashboard />
                        )
                      }
                    />
                  }
                  {
                    <Route
                      exact
                      path="/addcustomerbulkupload"
                      // component={AddCustomerBulkUpload}
                      render={() =>
                        isPermitted("/addcustomerbulkupload") ? (
                          <AddCustomerBulkUpload />
                        ) : (
                          <Dashboard />
                        )
                      }
                    />
                  }
                  {
                    <Route
                      exact
                      path="/filestatuses"
                      //  component={FileStatuses}
                      render={() =>
                        isPermitted("/filestatuses") ? (
                          <FileStatuses />
                        ) : (
                          <Dashboard />
                        )
                      }
                    />
                  }
                  {
                    <Route
                      exact
                      path="/filestatussummary"
                      // component={FileStatusSummary}
                      render={() =>
                        isPermitted("/filestatussummary") ? (
                          <FileStatusSummary />
                        ) : (
                          <Dashboard />
                        )
                      }
                    />
                  }
                  {
                    <Route
                      exact
                      path="/transactionreport"
                      component={TransactionReport}
                      // render={() => isPermitted("/transactionreport") ? <TransactionReport /> : <Dashboard />}
                    />
                  }
                  {
                    <Route
                      exact
                      path="/cashovercounter"
                      // component={CashOverCounter}
                      render={() =>
                        isPermitted("/cashovercounter") ? (
                          <CashOverCounter />
                        ) : (
                          <Dashboard />
                        )
                      }
                    />
                  }
                  {
                    <Route
                      exact
                      path="/utilitybillcollection"
                      // component={UtilityBillCollection}
                      render={() =>
                        isPermitted("/utilitybillcollection") ? (
                          <UtilityBillCollection />
                        ) : (
                          <Dashboard />
                        )
                      }
                    />
                  }
                  {
                    <Route
                      exact
                      path="/inwardclearing"
                      // component={InwardClearing}
                      render={() =>
                        isPermitted("/inwardclearing") ? (
                          <InwardClearing />
                        ) : (
                          <Dashboard />
                        )
                      }
                    />
                  }
                  {
                    <Route
                      exact
                      path="/authorizetransaction"
                      // component={AuthorizeTransaction}
                      render={() =>
                        isPermitted("/authorizetransaction") ? (
                          <AuthorizeTransaction />
                        ) : (
                          <Dashboard />
                        )
                      }
                    />
                  }
                  {
                    <Route
                      exact
                      path="/branchauthorization"
                      // component={BranchAuthorization}
                      render={() =>
                        isPermitted("/branchauthorization") ? (
                          <BranchAuthorization />
                        ) : (
                          <Dashboard />
                        )
                      }
                    />
                  }
                  {
                    <Route
                      exact
                      path="/generatepin"
                      //  component={GeneratePin}
                      render={() =>
                        isPermitted("/generatepin") ? (
                          <GeneratePin />
                        ) : (
                          <Dashboard />
                        )
                      }
                    />
                  }
                  {
                    <Route
                      exact
                      path="/singletransaction"
                      // component={singleTransaction}
                      render={() =>
                        isPermitted("/singletransaction") ? (
                          <singleTransaction />
                        ) : (
                          <Dashboard />
                        )
                      }
                    />
                  }
                  {
                    <Route
                      exact
                      path="/createsingletransaction"
                      // component={CreateSingleTransaction}
                      render={() =>
                        isPermitted("/createsingletransaction") ? (
                          <CreateSingleTransaction />
                        ) : (
                          <Dashboard />
                        )
                      }
                    />
                  }
                  {
                    <Route
                      exact
                      path="/authorizecompanytransaction"
                      // component={AuthCompanyTransaction}
                      render={() =>
                        isPermitted("/authorizecompanytransaction") ? (
                          <AuthCompanyTransaction />
                        ) : (
                          <Dashboard />
                        )
                      }
                    />
                  }
                  {
                    <Route
                      exact
                      path="/reviewtransaction"
                      // component={ReviewTransaction}
                      render={() =>
                        isPermitted("/reviewtransaction") ? (
                          <ReviewTransaction />
                        ) : (
                          <Dashboard />
                        )
                      }
                    />
                  }
                  {
                    <Route
                      exact
                      path="/bankmanagement"
                      // component={BankManagement}
                      render={() =>
                        isPermitted("/bankmanagement") ? (
                          <BankManagement />
                        ) : (
                          <Dashboard />
                        )
                      }
                    />
                  }
                  {
                    <Route
                      exact
                      path="/addbankmanagement"
                      // component={AddEditBankManagement}
                      render={() =>
                        isPermitted("/addbankmanagement") ? (
                          <AddEditBankManagement />
                        ) : (
                          <Dashboard />
                        )
                      }
                    />
                  }
                  {
                    <Route
                      exact
                      path="/bankbranchmanagement"
                      // component={BankBranchManagement}
                      render={() =>
                        isPermitted("/bankbranchmanagement") ? (
                          <BankBranchManagement />
                        ) : (
                          <Dashboard />
                        )
                      }
                    />
                  }
                  {
                    <Route
                      exact
                      path="/addbankbranchmanagement"
                      // component={() => (
                      //   <AddEditApproveBankBranchManagement type="Add" />
                      // )}
                      render={() =>
                        isPermitted("/addbankbranchmanagement") ? (
                          <AddEditApproveBankBranchManagement type="Add" />
                        ) : (
                          <Dashboard />
                        )
                      }
                    />
                  }
                  {
                    <Route
                      exact
                      path="/editbankbranchmanagement"
                      // component={() => (
                      //   <AddEditApproveBankBranchManagement type="Edit" />
                      // )}
                      render={() =>
                        isPermitted("/editbankbranchmanagement") ? (
                          <AddEditApproveBankBranchManagement type="Edit" />
                        ) : (
                          <Dashboard />
                        )
                      }
                    />
                  }
                  {
                    <Route
                      exact
                      path="/approvebankbranchmanagement"
                      // component={() => (
                      //   <AddEditApproveBankBranchManagement type="Approve" />
                      // )}
                      render={() =>
                        isPermitted("/approvebankbranchmanagement") ? (
                          <AddEditApproveBankBranchManagement type="Approve" />
                        ) : (
                          <Dashboard />
                        )
                      }
                    />
                  }
                  {
                    <Route
                      exact
                      path="/addbulkbranch"
                      // component={AddBulkBranch}
                      render={() =>
                        isPermitted("/addbulkbranch") ? (
                          <AddBulkBranch />
                        ) : (
                          <Dashboard />
                        )
                      }
                    />
                  }
                  {
                    <Route
                      exact
                      path="/bankbranchundefined"
                      // component={BankBranchUndefined}
                      render={() =>
                        isPermitted("/bankbranchundefined") ? (
                          <BankBranchUndefined />
                        ) : (
                          <Dashboard />
                        )
                      }
                    />
                  }
                  {
                    <Route
                      exact
                      path="/countrymanagement"
                      // component={CountryManagement}
                      render={() =>
                        isPermitted("/countrymanagement") ? (
                          <CountryManagement />
                        ) : (
                          <Dashboard />
                        )
                      }
                    />
                  }
                  {
                    <Route
                      exact
                      path="/addcountrymanagement"
                      // component={AddEditCountryManagement}
                      render={() =>
                        isPermitted("/addcountrymanagement") ? (
                          <AddEditCountryManagement />
                        ) : (
                          <Dashboard />
                        )
                      }
                    />
                  }
                  {
                    <Route
                      exact
                      path="/provincemanagement"
                      // component={ProvinceManagement}
                      render={() =>
                        isPermitted("/provincemanagement") ? (
                          <ProvinceManagement />
                        ) : (
                          <Dashboard />
                        )
                      }
                    />
                  }
                  {
                    <Route
                      exact
                      path="/addprovincemanagement"
                      // component={AddEditProvinceManagement}
                      render={() =>
                        isPermitted("/addprovincemanagement") ? (
                          <AddEditProvinceManagement />
                        ) : (
                          <Dashboard />
                        )
                      }
                    />
                  }
                  <Route
                    exact
                    path="/blockunblockaccount"
                    // component={BlockUnblockAccount}
                    render={() =>
                      isPermitted("/blockunblockaccount") ? (
                        <BlockUnblockAccount />
                      ) : (
                        <Dashboard />
                      )
                    }
                  />
                  <Route
                    exact
                    path="/accountstatementinquiry"
                    // component={AccountStatementInquiry}
                    render={() =>
                      isPermitted("/accountstatementinquiry") ? (
                        <AccountStatementInquiry />
                      ) : (
                        <Dashboard />
                      )
                    }
                  />
                  <Route
                    exact
                    path="/mpinresetinquiry"
                    // component={MpinResetInquiry}
                    render={() =>
                      isPermitted("/mpinresetinquiry") ? (
                        <MpinResetInquiry />
                      ) : (
                        <Dashboard />
                      )
                    }
                  />
                  <Route
                    exact
                    path="/unpostedtransactions"
                    // component={UnPostedTransaction}
                    render={() =>
                      isPermitted("/unpostedtransactions") ? (
                        <UnPostedTransaction />
                      ) : (
                        <Dashboard />
                      )
                    }
                  />
                  <Route
                    exact
                    path="/devicemanager"
                    //  component={DeviceManager}
                    render={() =>
                      isPermitted("/devicemanager") ? (
                        <DeviceManager />
                      ) : (
                        <Dashboard />
                      )
                    }
                  />
                  <Route
                    exact
                    path="/atmcardstatus"
                    //  component={AtmCardStatus}
                    render={() =>
                      isPermitted("/atmcardstatus") ? (
                        <AtmCardStatus />
                      ) : (
                        <Dashboard />
                      )
                    }
                  />
                  <Route
                    exact
                    path="/changecardpin"
                    // component={ChangeCardPin}
                    render={() =>
                      isPermitted("/changecardpin") ? (
                        <ChangeCardPin />
                      ) : (
                        <Dashboard />
                      )
                    }
                  />
                  <Route
                    exact
                    path="/analytics"
                    render={() =>
                      isPermitted("/analytics") ? <Analytics /> : <Dashboard />
                    }
                  />
                </Switch>
              </div>
            )}
          </Switch>
        </div>
      </div>
    </MenuContext.Provider>
  );
};

export default App;
